<div id="world" class="viewport-1" [ngClass]="worldZoomClass" [style.background-image]="'url(' + worldViewImage + ')'">
  <div class="viewport-1 full-fade-in" *ngIf="animateActiveLocation" [style.background-image]="'url(' + worldViewLocationBackground + ')'"></div>
  <ng-template ngFor let-overlayImage [ngForOf]="overlayImages">
    <img class="viewport-1" [src]="overlayImage"/>
  </ng-template>
  <congratulations *ngIf="displayCompletedMessage"></congratulations>
</div>